<script setup lang="ts"></script>

<template>
  <div class="exam-preparation-item">
    <div class="exam-preparation-item__title">
      <slot name="title" />
    </div>
    <div class="exam-preparation-item__content">
      <slot name="content" />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.exam-preparation-item {
  &__title {
    position: relative;
    z-index: 1;
    padding: 7px 20px;
    border-radius: 9px;
    background: rgb(@theme-colors[@secondary][50]);

    #media-breakpoint-up(md, {
      width: fit-content;
      margin-left: 5px;
    });
  }

  &__content {
    margin-top: -13px;
    padding: 30px 25px 13px;
    border-radius: 8px;
    background: white;
    box-shadow: 10px 10px 40px rgba(0, 0, 0, 0.1);
    white-space: pre-line;
  }
}
</style>
